var _g, _path, _path2, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _g4, _g5, _path9, _path0, _path1, _g6, _path10, _g7, _path11, _path12, _path13, _g8, _g9, _path14, _path15, _path16, _g0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapabilitiesStack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 602,
    viewBox: "0 0 440 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.642 405.556L220.586 365.198C219.974 365.083 219.349 365.082 218.737 365.197L2.71883 405.556L220.088 455.172C220.834 455.343 221.603 455.341 222.348 455.168L435.642 405.556Z",
    fill: "#F6DD8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 595.999C220.676 596.326 221.76 596.321 222.78 595.984L431.594 527.014C433.994 526.222 435.642 523.743 435.642 520.927L435.642 405.556L222.348 455.168C221.603 455.341 220.834 455.343 220.088 455.172L2.71883 405.556L2.71883 521.803C2.71883 524.638 4.39055 527.13 6.81356 527.905L219.653 595.999Z",
    fill: "url(#paint0_linear_8707_25018)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18843 521.803L3.18843 406.202L219.995 455.691C220.803 455.875 221.636 455.873 222.443 455.685L435.173 406.205L435.173 520.927C435.173 523.508 433.662 525.78 431.462 526.507L222.648 595.477C221.713 595.786 220.719 595.791 219.782 595.491L6.94195 527.396C4.72084 526.686 3.18844 524.402 3.18843 521.803ZM433.083 405.611L222.253 454.65C221.57 454.809 220.865 454.81 220.182 454.654L5.3093 405.608L218.813 365.718C219.375 365.613 219.947 365.614 220.509 365.719L433.083 405.611Z",
    stroke: "#262626"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 424.5L220.976 478.179L426.5 424.5",
    stroke: "#FFF9F9",
    strokeOpacity: 0.3,
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M286.618 444.781L226.286 461.301",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M220.482 365.821L231.284 368.303L37.8248 411.315L20.6397 405.427L220.482 365.821Z",
    fill: "#FFF0D8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.849 411.692L117.224 412.905C115.849 413.829 115.28 415.099 115.643 416.435C116.007 417.77 117.273 419.063 119.163 420.027L117.433 421.189C114.914 419.903 113.226 418.18 112.741 416.399C112.257 414.618 113.015 412.925 114.849 411.692V411.692ZM113.662 411.086C110.796 413.012 105.285 412.945 101.348 410.936C97.4116 408.926 96.5442 405.739 99.4103 403.813C102.276 401.887 107.787 401.954 111.724 403.964C115.66 405.973 116.528 409.16 113.662 411.086ZM111.286 409.874C113.197 408.59 112.619 406.465 109.994 405.126C107.37 403.786 103.696 403.741 101.786 405.025C99.8748 406.309 100.453 408.434 103.078 409.774C105.702 411.113 109.376 411.158 111.286 409.874ZM126.193 408.282L127.058 407.701L132.996 410.731L126.079 415.379L120.141 412.349L121.006 411.768L119.818 411.162C118.873 410.679 118.24 410.033 118.059 409.365C117.877 408.698 118.161 408.063 118.849 407.6C119.537 407.138 120.572 406.886 121.727 406.9C122.881 406.915 124.061 407.193 125.006 407.676L126.193 408.282ZM124.464 409.444L123.277 408.838C122.962 408.677 122.568 408.584 122.184 408.579C121.799 408.575 121.454 408.658 121.224 408.813C120.995 408.967 120.9 409.178 120.961 409.401C121.021 409.624 121.232 409.839 121.547 410L122.735 410.606L124.464 409.444Z",
    fill: "#A87F05"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M220 585L220 507",
    stroke: "white",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.642 283.94L220.582 243.28C219.972 243.165 219.35 243.165 218.74 243.28L2.71882 283.941L220.093 333.928C220.836 334.099 221.601 334.098 222.344 333.924L435.642 283.94Z",
    fill: "#99BFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66 426.997C220.678 427.326 221.758 427.321 222.774 426.982L431.611 357.49C434.001 356.695 435.642 354.208 435.642 351.383L435.642 283.94L222.344 333.924C221.601 334.098 220.836 334.099 220.093 333.928L2.71882 283.941L2.71882 352.265C2.71882 355.11 4.38358 357.61 6.79651 358.388L219.66 426.997Z",
    fill: "url(#paint1_linear_8707_25018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18646 352.265L3.18646 284.589L220 334.448C220.805 334.633 221.634 334.632 222.438 334.443L435.175 284.592L435.175 351.383C435.175 353.973 433.67 356.252 431.479 356.981L222.642 426.474C221.711 426.783 220.721 426.788 219.788 426.487L6.92436 357.877C4.71249 357.164 3.18647 354.873 3.18646 352.265ZM433.093 283.996L222.249 333.404C221.569 333.564 220.867 333.565 220.186 333.409L5.2985 283.993L218.817 243.803C219.376 243.698 219.946 243.698 220.505 243.803L433.093 283.996Z",
    stroke: "#434343"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M221 378L221 417",
    stroke: "white",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 298.5L220.976 358.113L427 298.5",
    stroke: "#FFF9F9",
    strokeOpacity: 0.3,
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M286.618 324.466L226.286 341.11",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M220.482 244.916L231.284 247.417L37.8248 290.75L20.6397 284.818L220.482 244.916Z",
    fill: "#0F3A85"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.907 289.237L97.3704 287.369C97.0577 287.204 96.8479 286.983 96.7872 286.754C96.7265 286.526 96.8198 286.309 97.0466 286.151L107.308 279.013C107.535 278.855 107.876 278.77 108.258 278.775C108.639 278.78 109.029 278.876 109.342 279.041L125.847 287.761C126.159 287.926 126.369 288.147 126.43 288.375C126.491 288.604 126.397 288.821 126.171 288.978L123.605 290.763L127.142 292.632C127.793 292.975 127.936 293.522 127.46 293.853L117.21 300.983C117.099 301.062 116.957 301.124 116.794 301.166C116.631 301.207 116.449 301.228 116.259 301.225C116.07 301.223 115.876 301.199 115.689 301.153C115.502 301.107 115.326 301.042 115.17 300.959L98.6681 292.238C98.0174 291.894 97.874 291.347 98.3495 291.017L100.907 289.237ZM101.556 291.672L115.702 299.147L124.253 293.198L110.106 285.724L101.556 291.672ZM102.617 288.048L109.458 283.289L121.247 289.517L122.958 288.328L108.811 280.854L100.26 286.802L102.617 288.048ZM106.802 292.352L111.932 288.783L114.29 290.028L109.16 293.597L106.802 292.352ZM111.517 294.843L116.648 291.274L119.006 292.52L113.875 296.089L111.517 294.843Z",
    fill: "#0F3A85"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.642 183.941L220.582 143.28C219.972 143.165 219.35 143.165 218.74 143.28L2.71902 183.941L220.093 233.928C220.836 234.099 221.602 234.098 222.344 233.924L435.642 183.941Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66 299.871C220.678 300.199 221.758 300.194 222.774 299.856L431.61 230.363C434 229.568 435.642 227.081 435.642 224.256L435.642 183.941L222.344 233.924C221.602 234.098 220.836 234.099 220.093 233.928L2.71902 183.941L2.71902 225.138C2.71902 227.983 4.38377 230.483 6.7967 231.261L219.66 299.871Z",
    fill: "url(#paint2_linear_8707_25018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18667 225.138L3.18666 184.589L220 234.448C220.805 234.633 221.634 234.632 222.438 234.443L435.175 184.592L435.175 224.256C435.175 226.846 433.67 229.125 431.479 229.854L222.642 299.347C221.711 299.657 220.721 299.662 219.788 299.361L6.92454 230.75C4.71269 230.037 3.18668 227.746 3.18667 225.138ZM433.093 183.996L222.249 233.404C221.569 233.564 220.867 233.565 220.186 233.409L5.2987 183.993L218.817 143.803C219.376 143.698 219.946 143.698 220.505 143.804L433.093 183.996Z",
    stroke: "#434343"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 198L220.976 258.113L426 198",
    stroke: "#FFF9F9",
    strokeOpacity: 0.3,
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M286.618 224.466L226.286 241.11",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M220.483 144.916L231.284 147.417L37.8252 190.75L20.6402 184.818L220.483 144.916Z",
    fill: "#8A969E"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.077 189.377C112.211 188.589 113.919 188.16 115.827 188.186C117.734 188.213 119.684 188.691 121.247 189.517L128.321 193.254L126.61 194.444L119.537 190.707C118.635 190.23 117.517 189.946 116.411 189.911C115.306 189.877 114.297 190.095 113.591 190.521L113.435 190.623C112.78 191.078 112.495 191.698 112.638 192.356C112.781 193.015 113.341 193.661 114.203 194.164L114.406 194.276L121.48 198.013L119.769 199.203L112.696 195.466C111.133 194.64 110.084 193.534 109.78 192.393C109.476 191.251 109.943 190.166 111.077 189.377ZM109.055 195.112C109.294 194.946 109.565 194.806 109.859 194.689C110.313 195.108 110.851 195.498 111.458 195.849L111.841 196.061L111.942 196.114C111.795 196.157 111.662 196.211 111.543 196.276L111.413 196.358C111.094 196.58 110.951 196.88 111.01 197.201C111.07 197.521 111.328 197.838 111.735 198.091L111.899 198.185L117.204 200.987L115.494 202.177L110.189 199.374C109.094 198.796 108.36 198.022 108.148 197.223C107.935 196.424 108.262 195.665 109.055 195.112V195.112ZM120.172 187.379C120.966 186.827 122.162 186.527 123.497 186.546C124.832 186.564 126.197 186.899 127.291 187.477L132.596 190.28L130.886 191.47L125.581 188.667C125.141 188.435 124.599 188.293 124.059 188.271C123.519 188.248 123.021 188.345 122.661 188.544L122.53 188.625C122.38 188.729 122.272 188.848 122.202 188.975L122.102 188.922C121.317 188.508 120.47 188.173 119.593 187.92C119.74 187.727 119.933 187.545 120.172 187.379ZM101.982 191.375C102.549 190.981 103.403 190.767 104.357 190.78C105.31 190.793 106.285 191.032 107.067 191.445C107.849 191.858 108.373 192.411 108.525 192.982C108.677 193.553 108.443 194.095 107.877 194.49C107.31 194.884 106.455 195.098 105.502 195.085C104.548 195.072 103.573 194.833 102.791 194.42C102.01 194.007 101.485 193.454 101.334 192.883C101.182 192.312 101.415 191.77 101.982 191.375V191.375ZM113.098 183.642C113.665 183.248 114.52 183.034 115.473 183.047C116.427 183.06 117.402 183.299 118.183 183.712C118.965 184.125 119.49 184.678 119.641 185.249C119.793 185.82 119.56 186.362 118.993 186.757C118.426 187.151 117.572 187.365 116.618 187.352C115.664 187.339 114.69 187.1 113.908 186.687C113.126 186.274 112.602 185.721 112.45 185.15C112.298 184.579 112.531 184.037 113.098 183.642V183.642ZM104.34 192.621C104.226 192.7 104.18 192.808 104.21 192.923C104.24 193.037 104.345 193.147 104.502 193.23C104.658 193.313 104.853 193.36 105.044 193.363C105.234 193.366 105.405 193.323 105.519 193.244C105.632 193.165 105.679 193.057 105.648 192.942C105.618 192.828 105.513 192.718 105.357 192.635C105.2 192.552 105.005 192.505 104.815 192.502C104.624 192.499 104.453 192.542 104.34 192.621ZM115.456 184.888C115.343 184.967 115.296 185.075 115.327 185.19C115.357 185.304 115.462 185.414 115.618 185.497C115.774 185.579 115.969 185.627 116.16 185.63C116.351 185.633 116.522 185.59 116.635 185.511C116.749 185.432 116.795 185.323 116.765 185.209C116.734 185.095 116.63 184.985 116.473 184.902C116.317 184.819 116.122 184.772 115.931 184.769C115.74 184.766 115.57 184.809 115.456 184.888ZM100.467 183.772C101.374 183.141 102.741 182.798 104.266 182.819C105.792 182.84 107.352 183.223 108.603 183.884C109.853 184.545 110.693 185.429 110.935 186.342C111.178 187.256 110.805 188.123 109.898 188.755C108.991 189.386 107.624 189.728 106.098 189.707C104.572 189.686 103.013 189.303 101.762 188.643C100.511 187.982 99.6721 187.097 99.4292 186.184C99.1863 185.271 99.5595 184.403 100.467 183.772V183.772ZM102.824 185.017C102.371 185.333 102.184 185.767 102.306 186.224C102.427 186.68 102.847 187.122 103.472 187.453C104.097 187.783 104.877 187.975 105.64 187.985C106.403 187.996 107.087 187.824 107.54 187.509C107.994 187.193 108.18 186.759 108.059 186.303C107.937 185.846 107.518 185.404 106.893 185.073C106.267 184.743 105.487 184.552 104.724 184.541C103.961 184.531 103.278 184.702 102.824 185.017V185.017Z",
    fill: "#595959"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M221 278L221 290",
    stroke: "white",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.642 111.941L220.582 71.2804C219.972 71.1651 219.35 71.1649 218.74 71.2796L2.7189 111.941L220.093 161.928C220.836 162.099 221.602 162.098 222.344 161.924L435.642 111.941Z",
    fill: "#C6DCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66 207.871C220.678 208.199 221.758 208.194 222.774 207.856L431.611 138.363C434.001 137.568 435.642 135.081 435.642 132.256L435.642 111.941L222.344 161.924C221.602 162.098 220.836 162.099 220.093 161.928L2.7189 111.941V133.139C2.7189 135.984 4.38366 138.483 6.79659 139.261L219.66 207.871Z",
    fill: "url(#paint3_linear_8707_25018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18654 133.139L3.18654 112.589L220 162.448C220.805 162.633 221.634 162.632 222.438 162.443L435.175 112.592L435.175 132.256C435.175 134.846 433.67 137.125 431.479 137.854L222.642 207.347C221.711 207.657 220.721 207.662 219.788 207.361L6.92444 138.75C4.71257 138.038 3.18656 135.746 3.18654 133.139ZM433.093 111.996L222.249 161.404C221.569 161.564 220.867 161.565 220.186 161.409L5.29858 111.993L218.817 71.8029C219.376 71.6977 219.946 71.6979 220.505 71.8036L433.093 111.996Z",
    stroke: "#434343"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 125L220.976 186.113L429.5 125",
    stroke: "#FFF9F9",
    strokeOpacity: 0.3,
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M286.618 152.466L226.286 169.11",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M220.483 72.9164L231.284 75.4167L37.8252 118.75L20.6402 112.818L220.483 72.9164Z",
    fill: "#144B2D"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7929 114.908L98.2946 116.23L96.48 117.492L101.484 120.135C104.248 121.596 108.111 121.649 110.116 120.254C112.122 118.859 111.507 116.547 108.742 115.086L103.739 112.443L101.924 113.705L99.4221 112.383L102.144 110.49C102.645 110.141 103.612 110.155 104.302 110.519L110.557 113.824C114.276 115.788 115.4 118.783 113.422 120.89L115.402 121.936C117.82 123.213 121.202 123.26 122.956 122.04C124.314 121.095 124.298 119.667 123.096 118.477C121.562 118.83 119.588 118.595 118.062 117.789C115.989 116.694 115.528 114.959 117.031 113.913C118.535 112.867 121.433 112.907 123.506 114.002C125.221 114.908 125.832 116.253 125.141 117.282C127.544 119.234 127.779 121.747 125.457 123.362C122.701 125.279 117.387 125.206 113.587 123.198L111.607 122.152C108.437 123.629 103.388 123.362 99.6689 121.398L93.4145 118.093C92.724 117.729 92.5701 117.15 93.0709 116.801L95.7929 114.908ZM119.533 115.234C119.032 115.583 119.186 116.162 119.877 116.527C120.567 116.891 121.534 116.905 122.035 116.556C122.536 116.208 122.382 115.629 121.691 115.264C121.001 114.899 120.034 114.886 119.533 115.234Z",
    fill: "#144B2D"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.642 51.5558L220.586 11.1976C219.974 11.0827 219.349 11.0824 218.737 11.1968L2.71883 51.5558L220.088 101.172C220.834 101.343 221.603 101.341 222.348 101.168L435.642 51.5558Z",
    fill: "#FBCFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.905 117.059C220.769 117.288 221.668 117.284 222.53 117.048L431.341 59.7645C433.866 59.0719 435.642 56.5261 435.642 53.601L435.642 51.5558L222.348 101.168C221.603 101.341 220.834 101.343 220.088 101.172L2.71883 51.5558L2.71883 54.4786C2.71883 57.4221 4.51755 59.979 7.06279 60.6536L219.905 117.059Z",
    fill: "#FBCFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18844 54.4785L3.18843 52.2024L219.995 101.69C220.803 101.875 221.636 101.873 222.444 101.685L435.173 52.2048L435.173 53.601C435.173 56.2823 433.544 58.616 431.23 59.2508L222.419 116.534C221.629 116.751 220.804 116.754 220.012 116.545L7.1704 60.139C4.83726 59.5207 3.18844 57.1768 3.18844 54.4785ZM433.083 51.6114L222.253 100.65C221.57 100.809 220.865 100.81 220.182 100.654L5.3093 51.6077L218.813 11.7183C219.375 11.6135 219.947 11.6137 220.509 11.719L433.083 51.6114Z",
    stroke: "#434343"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 56L220.976 111.179L431 55",
    stroke: "#FFF9F9",
    strokeOpacity: 0.3,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M286.618 91.7808L226.286 108.301",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M220.483 12.8208L231.284 15.3025L37.8252 58.3148L20.6402 52.427L220.483 12.8208Z",
    fill: "#F58E7D"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8707_25018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4102 50.8131L108.683 47.1458C108.934 47.0467 109.252 47.0063 109.586 47.0311C109.92 47.0559 110.249 47.1446 110.519 47.2825L122.38 53.3356C123.553 53.9343 124.497 54.6654 125.128 55.4641C125.759 56.2627 126.058 57.1041 125.998 57.9137L125.538 64.1474L115.056 65.2668C113.695 65.4122 112.231 65.3539 110.794 65.097C109.357 64.8401 107.991 64.3926 106.818 63.7942L94.9566 57.7404C94.6865 57.6025 94.4915 57.4237 94.4038 57.2334C94.3162 57.0432 94.3411 56.8529 94.4745 56.6939L99.4102 50.8131ZM101.844 52.055L97.6382 57.0645L108.546 62.6316C109.328 63.0307 110.239 63.3291 111.197 63.5005C112.155 63.6719 113.131 63.7108 114.039 63.6139L122.684 62.691L123.063 57.5495C123.103 57.0099 122.904 56.4491 122.483 55.9169C122.063 55.3846 121.433 54.8973 120.652 54.4982L109.742 48.9305L101.844 52.055Z",
    fill: "#B9503E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.479 57.4403L109.061 52.228L111.468 52.2574L111.72 53.1856L114.127 53.2151L114.759 55.536L112.352 55.5066L112.886 57.4694C113.845 57.6476 114.721 58.0076 115.355 58.4844C115.989 58.9612 116.339 59.5234 116.343 60.0693C116.346 60.6153 116.003 61.1091 115.375 61.4614C114.747 61.8137 113.875 62.0014 112.917 61.9905C111.958 61.9792 110.976 61.7695 110.15 61.3995C109.324 61.0294 108.707 60.5235 108.412 59.9733C108.118 59.4231 108.164 58.8651 108.543 58.4004C108.922 57.9358 109.609 57.5951 110.479 57.4403ZM113.89 59.6892C113.86 59.566 113.788 59.4431 113.678 59.3276C113.568 59.2121 113.422 59.1065 113.248 59.0167C113.075 58.927 112.878 58.8549 112.668 58.8049C112.459 58.7548 112.241 58.7277 112.028 58.7251C111.815 58.7224 111.611 58.7444 111.427 58.7897C111.243 58.8349 111.084 58.9026 110.959 58.9887C110.833 59.0748 110.744 59.1776 110.696 59.2911C110.649 59.4047 110.643 59.5266 110.68 59.6499C110.754 59.8934 110.989 60.1275 111.336 60.3018C111.682 60.4761 112.112 60.5767 112.533 60.5818C112.954 60.587 113.332 60.4963 113.586 60.3293C113.839 60.1624 113.949 59.9325 113.89 59.6892Z",
    fill: "#B9503E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8707_25018",
    x: 2.71875,
    y: 365.111,
    width: 436.924,
    height: 235.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8707_25018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8707_25018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8707_25018",
    x: 2.71875,
    y: 243.194,
    width: 436.924,
    height: 188.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8707_25018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8707_25018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8707_25018",
    x: 2.71924,
    y: 143.194,
    width: 436.923,
    height: 160.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8707_25018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8707_25018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8707_25018",
    x: 2.71875,
    y: 71.1937,
    width: 436.924,
    height: 140.919,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8707_25018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8707_25018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_8707_25018",
    x: 2.71875,
    y: 11.1112,
    width: 436.924,
    height: 110.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8707_25018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8707_25018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8707_25018",
    x1: 219.783,
    y1: 144.501,
    x2: 217.801,
    y2: 716.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#FFE796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8707_25018",
    x1: 218.977,
    y1: 110.551,
    x2: 218.977,
    y2: 530,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#99BFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#0F3A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8707_25018",
    x1: 219.001,
    y1: 219.5,
    x2: 219.001,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A969E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8707_25018",
    x1: 219.001,
    y1: 145.5,
    x2: 227.324,
    y2: 211.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DCD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#144B2D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8707_25018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 32,
    fill: "white",
    transform: "matrix(0.830004 -0.557758 0.890707 0.454578 87.8477 410.179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8707_25018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 32,
    fill: "white",
    transform: "matrix(0.820909 -0.571059 0.884188 0.467131 87.8477 189.664)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8707_25018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 32,
    fill: "white",
    transform: "matrix(0.830004 -0.557758 0.890707 0.454578 87.8477 57.179)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapabilitiesStack1);
export default __webpack_public_path__ + "static/media/capabilities-stack-1.7ee1d8b3a66bb9f5e21f88387fc3310d.svg";
export { ForwardRef as ReactComponent };